'use strict';

var wishlist = require('wishlist:wishlist/wishlist');
const attributesLogic = require('./../product/attributes');

/**
* Displays an empty wishlist message
*/
function displayEmptyWishlist() {
    var message = $('#emptyWishlistMessage').val();

    $('.landing-guest-description').remove();
    $('.wishlist-container').empty().append('<div class="container wishlist-empty">'
        + '<div class="row">'
        + '    <div class="col-12 d-flex align-items-center flex-column">'
        + '        <i class="icon icon-pictoWishList-grey"></i>'
        + '        <span class=" text-muted mt-2">' + message + '</span>'
        + '    </div>'
        + '</div>'
        + '</div>');
}

/**
 * renders the list up to a given page number
 * @param {number} pageNumber - current page number
 * @param {boolean} spinner - if the spinner has already started
 * @param {string} focusElementSelector - selector of the element to focus on
 */
function renderNewPageOfItems(pageNumber, spinner, focusElementSelector) {
    var publicView = $('.wishlistItemCardsData').data('public-view');
    var listUUID = $('.wishlistItemCardsData').data('uuid');
    var url = $('.wishlistItemCardsData').data('href');
    if (spinner) {
        $.spinner().start();
    }
    var scrollPosition = document.documentElement.scrollTop;
    var newPageNumber = pageNumber;
    $.ajax({
        url: url,
        method: 'get',
        data: {
            // eslint-disable-next-line no-plusplus
            pageNumber: ++newPageNumber,
            publicView: publicView,
            id: listUUID
        }
    }).done(function (data) {
        var productCount = $(data).find('.product-info').length;
        if (productCount === 0) {
            displayEmptyWishlist();
        } else {
            $('.wishlistItemCards').empty().append(data);

            if (focusElementSelector) {
                $(focusElementSelector).focus();
            } else {
                document.documentElement.scrollTop = scrollPosition;
            }
        }
    }).fail(function () {
        $('.more-wl-items').remove();
    });
    $.spinner().stop();
}

/**
 * @param {Object} $elementToAppend - The element to append error html to
 * @param {string} msg - The error message
 * display error message if remove item from wishlist failed
 */
function displayErrorMessage($elementToAppend, msg) {
    if ($('.remove-from-wishlist-messages').length === 0) {
        $elementToAppend.append('<div class="remove-from-wishlist-messages"></div>');
    }
    $('.remove-from-wishlist-messages').append('<div class="remove-from-wishlist-alert text-center alert-danger">' + msg + '</div>');

    setTimeout(function () {
        $('.remove-from-wishlist-messages').remove();
    }, 3000);
}

/**
* Handles the click event on the remove button of a wishlist item.
* @param {Object} e - The click event
* @param {string} action - The URL of the action to be called
*/
$('body').on('product:removeFromWishlist', function (e, action) {
    e.preventDefault();
    var url = action;
    var elMyAccount = $('.account-wishlist-item').length;
    // If user is in my account page, call removeWishlistAccount() end point, re-render wishlist cards
    if (elMyAccount > 0) {
        $('.wishlist-account-card').spinner().start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'html',
            data: {},
            success: function (html) {
                var wishlistaccountcard = $('.wishlist-account-card');
                wishlistaccountcard.find('.card').remove();
                wishlistaccountcard.append(html);
                wishlistaccountcard.spinner().stop();
            },
            error: function () {
                var $elToAppend = $('.wishlist-account-card');
                $elToAppend.spinner().stop();
                var msg = $elToAppend.data('error-msg');
                displayErrorMessage($elToAppend, msg);
            }
        });
        // else user is in wishlist landing page, call removeProduct() end point, then remove this card
    } else {
        $.spinner().start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            data: {},
            success: function (data) {
                var pageNumber = $('.wishlistItemCardsData').data('page-number') - 1;
                renderNewPageOfItems(pageNumber, false);
                setHeartIconOnRemove(data);
            },
            error: function () {
                $.spinner().stop();
                var $elToAppendWL = $('.wishlistItemCards');
                var msg = $elToAppendWL.data('error-msg');
                displayErrorMessage($elToAppendWL, msg);
            }
        });
    }
});

/**
* Sets the heart icon to the default state when a product is removed from the wishlist
* @param {Object} data - Object containing the query string of the product
*/
function setHeartIconOnRemove(data) {
    if (data && data.queryString && data.queryString.length) {
        $(`.wishlistHeart[data-${data.queryString}] .fa-heart-icon-clicked`).removeClass('fa-heart-icon-clicked').addClass('fa-heart-icon');
    }
}

/**
* Parses the given HTML string and returns the product quickview element
* @param {string} html - the HTML string to parse
* @returns {Object} - the product quickview element
*/
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));
    return $html.find('.product-quickview');
}

/**
* Fills the modal element with the selected value URL
* @param {string} selectedValueUrl - the URL of the selected value
*/
function fillModalElement(selectedValueUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);
            var $editWishlistProductModal = $('#editWishlistProductModal');
            $editWishlistProductModal.find('.modal-body').empty().html(parsedHtml).find('.quick-view-carousel-area')
                .addClass('d-none');
            var fullPdpLink = $('.full-pdp-link');
            fullPdpLink.text(data.quickViewFullDetailMsg);
            fullPdpLink.attr('href', data.productUrl);
            $('.size-chart', $editWishlistProductModal).attr('href', data.productUrl);
            $('.modal-header .close .sr-only', $editWishlistProductModal).text(data.closeButtonText);
            $('.enter-message', $editWishlistProductModal).text(data.enterDialogMessage);
            $($editWishlistProductModal.find('.add-to-cart-global')[0]).addClass('add-to-cart-wishlist');
            $editWishlistProductModal.modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
* Creates a modal element to be used for editing a product in a wishlist
*/
function getModalHtmlElement() {
    if ($('#editWishlistProductModal').length !== 0) {
        $('#editWishlistProductModal').remove();
    }
    var htmlString = ''
        + '<div class="modal fade" id="editWishlistProductModal" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">'
        + '        <span class="close-btn"></span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '</div>'
        + '</div>'
        + '</div>';

    var $modalEl = $(htmlString);
    $modalEl.on('shown.bs.modal', function () {
        // this event will be catched to be used to initialize slick slider
        $('body').trigger('quickview:ready', $(this));
    });
    $('body').append($modalEl);
}

/**
* Updates the Add To Cart button based on the given parameter
* @param {boolean} disableButton - whether to disable the button or not
*/
function updateAddToCartButton(disableButton) {
    const $addToCartButton = $('.add-to-cart-global');
    $addToCartButton.attr('disabled', disableButton);

    const $section = $addToCartButton.closest('.add-to-cart-section');
    if ($section.length > 0) {
        if (disableButton) {
            $addToCartButton.text($section.attr('data-text-choose'));
        } else {
            $addToCartButton.text($section.attr('data-text-ready'));
        }
    }
}

/**
* Initializes the quick view logic
* @returns {undefined}
*/
function initQuickViewLogic() {
    // Init event on document ready
    $(function () {
        $('body').on('click', '.attribute-values .circle-unselected', attributesLogic.selectAttributeValue);

        $('body').on('product:updateAddToCart', function (e, response) {
            const disableButton = (!response.product.readyToOrder || !response.product.available);
            updateAddToCartButton(disableButton);
            if (response.product) $('.add-to-cart-global').attr('data-pid', response.product.id);
        });
        // eslint-disable-next-line no-unused-vars
        $('body').on('quickview:ready', function (e, response) {
            $('.alert-incompatible-shipping-methods').html($('#incompatible-shipping-methods-message-holder').html());
        });
    });
}

/**
* Handles the request for adding a product to the cart from the wishlist page
* @param {string} pid - The product ID of the item to add
* @returns {void}
*/
function handleRequest(pid) {
    var aButton;
    $('.move-to-cart.wishlist-button-swatch').each(function () {
        if (pid.includes($(this).data('pid'))) {
            aButton = $(this);
        }
    });
    var addToCart = aButton ? aButton.data('add-url') : '';
    var removeProductUrl = aButton ? aButton.data('action') : '';
    $.ajax({
        url: addToCart,
        type: 'POST',
        data: {
            pid: pid,
            pagetype: window.GTMConstants.PAGE_CATEGORY_WISHLIST
        },
        success: function (data) {
            displayMessage(data);
            $('body').trigger('product:afterAddToCart', data);
            $('body').trigger('product:removeFromWishlist', removeProductUrl);
            $('.minicart').trigger('count:update', data);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
* Displays a message on the page
* @param {Object} data - an object containing the message and an error flag
*/
function displayMessage(data) {
    $.spinner().stop();

    var status;
    if (data.error) {
        status = 'alert-danger';
    } else {
        status = 'alert-success';
    }

    if ($('.add-to-cart-from-wishlist-messages').length === 0) {
        $('body').append('<div class="add-to-cart-from-wishlist-messages ' + status + '"></div>');
    }

    var $wishlistMsg = $('.add-to-cart-from-wishlist-messages');
    $wishlistMsg.append('<div class="add-to-cart-from-wishlist-alert text-center">' + data.message + '</div>');

    setTimeout(function () {
        $wishlistMsg.remove();
    }, 3000);
}

/**
* Updates the wishlist page when a new item is added
* @returns {void}
*/
function updateWishListOnWishListPage() {
    if ($('.wishlist-container').length) {
        $('body').on('wishlist:addItem', function () {
            if ($('.wishlistItemCards').length) {
                var pageNumber = $('.wishlistItemCardsData').data('page-number') - 1;
                renderNewPageOfItems(pageNumber, true);
            } else if ($('.wishlist-empty').length) {
                window.location.reload();
            }
        });
    }
}

module.exports = {
    ...wishlist,
    ...{
        getModalHtmlElement,
        initQuickViewLogic,
        /**
        * Event handler for editing a product from the wishlist
        * @param {Object} e - the event object
        * @returns {void}
        */
        viewProductViaEdit: function () {
            $('body').on('click', '.edit-add-to-wishlist .edit', function (e) {
                e.preventDefault();
                e.stopPropagation();

                var editProductUrl = $(this).attr('href');
                $(e.target).trigger('editwishlistproduct:show');
                getModalHtmlElement();
                fillModalElement(editProductUrl);
            });
        },
        /**
        * Handles the click event on the move-to-cart.wishlist-button-swatch element
        * @param {Object} evt - The click event object
        * @param {Object} moveToCartButton - The jQuery object of the clicked element
        * @param {string} moveToCartButton.data('wishlist-url') - The URL of the wishlist page
        * @param {string} moveToCartButton.data('pid') - The product ID of the item
        */
        handleModal: function () {
            $(document).on('click', '.move-to-cart.wishlist-button-swatch', function (evt) {
                evt.preventDefault();
                var moveToCartButton = $(this);
                if (moveToCartButton.closest('div').find('.enable-add-to-cart').val() == 'null') {
                    $.spinner().start();
                    getModalHtmlElement();
                    fillModalElement(moveToCartButton.data('wishlist-url'));
                    $.spinner().stop();
                } else {
                    handleRequest(moveToCartButton.data('pid'));
                }
            });
        },
        /**
        * Handles the click event for the 'Add to Cart' button on the wishlist page
        * @param {Event} evt - the click event
        * @param {string} pid - the product ID
        */
        addToCart: function () {
            $(document).on('click', '.add-to-cart-wishlist', function (evt) {
                evt.preventDefault();
                $.spinner().start();
                var pid = $(this).data('pid');
                handleRequest(pid);
                $.spinner().stop();
            });
        },
        /**
        * Event handler for removing a product from the wishlist
        * @param {string} removeProductUrl - URL of the product to be removed
        */
        removeFromWishlist: function () {
            $('body').on('click', '.remove-product-from-wishlist', function () {
                var removeProductUrl = $(this).data('url');
                $('body').trigger('product:removeFromWishlist', removeProductUrl);
            });
        },
        /**
        * Initializes the product recommendation slick
        */
        initSlick: function () {
            const recommendationUtils = require('../components/recommendations');
            recommendationUtils.initRecommandationLogic();
            recommendationUtils.initProductRecommendationSlick();
        },
        /**
        * Hides the edit wishlist product modal after product is added to cart
        */
        hideDialog: function () {
            $('body').on('product:afterAddToCart', function () {
                $('#editWishlistProductModal').modal('hide');
            });
        },
        updateWishListOnWishListPage
    }
};
